'use client';

import { useEffect } from 'react';
import { create } from 'zustand';
import { getApiBaseUrl } from '@/utils/apiBaseUrl';
import { recordDeviceAccount } from '@/utils/deviceAccounts';
import { readJson, stringField } from '@/lib/jsonBody';

interface AuthState {
  isAuthenticated: boolean;
  hydrated: boolean;
  userId: string | null;
  // WHY: Telegram подписывает initData один раз на запуск — протухший не обновить до переоткрытия мини-аппа
  sessionExpired: boolean;
  markAuthed: (userId: string) => void;
  markAnon: () => void;
  markSessionExpired: () => void;
  _rehydrate: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  hydrated: false,
  userId: null,
  sessionExpired: false,

  markSessionExpired: () => {
    set({ sessionExpired: true });
  },

  markAuthed: (userId: string) => {
    recordDeviceAccount(userId);
    set({ isAuthenticated: true, userId, hydrated: true });
  },

  markAnon: () => {
    set({ isAuthenticated: false, userId: null, hydrated: true });
  },

  _rehydrate: async () => {
    if (typeof window === 'undefined') return;
    try {
      const res = await fetch(`${getApiBaseUrl()}/api/auth/me`, {
        method: 'GET',
        credentials: 'include',
        headers: { 'X-Requested-With': 'shot' },
      });
      if (res.ok) {
        const userId = stringField(await readJson(res), 'userId');
        if (userId) {
          recordDeviceAccount(userId);
          set({ isAuthenticated: true, userId, hydrated: true });
          return;
        }
      }
      set({ isAuthenticated: false, userId: null, hydrated: true });
    } catch {
      set({ isAuthenticated: false, userId: null, hydrated: true });
    }
  },
}));

export function useAuthStoreHydrate(): void {
  useEffect(() => {
    void useAuthStore.getState()._rehydrate();
  }, []);
}
